var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step1" }, [
    _vm.rows.length > 0
      ? _c(
          "div",
          [
            _c("vue-good-table", {
              attrs: {
                columns: _vm.columns,
                rows: _vm.rows,
                "sort-options": {
                  enabled: false
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "button-con" },
              [
                _c("CButton", {
                  attrs: { color: "green", text: "Allocate Order" },
                  on: { click: _vm.onNext }
                })
              ],
              1
            )
          ],
          1
        )
      : _c("div", [
          _c("span", [
            _vm._v(
              "There are no remaining items eligible for Allocation in this order."
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }